<mat-card class="min-h-28 w-96" [ngClass]="getSeverityCardClass()">
    <div class="grid grid-cols-12" [ngClass]="getSeverityTextClass()">
        <div class="col-span-11 p-4 pb-0">
            <span class="font-medium">{{ getAlertLabel() }}:</span>
        </div>
        <div class="col-span-1 pt-4">
            <mat-icon (click)="closeAlert()" class="cursor-pointer"
                >close</mat-icon
            >
        </div>
    </div>
    <div class="grid grid-cols-12">
        <div class="col-span-10 pl-4">
            {{ alert.message }}
        </div>
    </div>
    <div class="grid grid-cols-12 pb-4">
        @if (alert.options.apiErrorGuid) {
            <div class="col-span-10 mt-2 pl-4 text-xs">
                Internal use only: {{ alert.options.apiErrorGuid }}
            </div>
        }
    </div>
</mat-card>
